import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CoreModule, provideErrorTracking, cookielessBearerHostInterceptor } from '@galaxy/core';
import { LexiconModule } from '@galaxy/lexicon';
import { FeatureFlagService, PartnerService } from '@galaxy/partner';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyNavModule } from '@vendasta/galaxy/nav';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyDefaultProviderOverrides } from '@vendasta/galaxy/provider-default-overrides';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { OAuth2ServiceConfigToken } from '@vendasta/oauth2';
import { UIKitModule } from '@vendasta/uikit';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import baseTranslation from '../assets/i18n/en_devel.json';
import { AppComponent } from './app.component';
import { AuthService, oauth2ConfigFactory } from './auth/auth.service';
import { WEBLATE_COMPONENT_NAME } from './constants';
import { ApiErrorFactory } from './core/api-errors';
import { AppConfigService } from './core/appconfig/app-config.service';
import { UptimeService } from './core/uptime/uptime.service';
import { WordpressSiteService } from './core/wordpress-site/wordpress-site.service';
import { WspAdminCenterModule } from './core/wsp_admin_center_sdk/wsp-admin-center.module';
import { SelectedPartnerService } from './selected-partner.service';
import { EntryComponent } from './views/entry/entry.component';
import { RedirectEntryComponent } from './views/entry/redirect-entry.component';
import { AppFailureComponent } from './views/failure/app-failure.component';
import { HomeComponent } from './views/home/home.component';
import { AppInsufficientPermissionComponent } from './views/insufficient-permission/app-insufficient-permission.component';
import { routes } from './views/routes';
import { provideProtoTransport } from '@vendasta/protos';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AppFailureComponent,
    AppInsufficientPermissionComponent,
    EntryComponent,
    RedirectEntryComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    LexiconModule.forRoot({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyNavModule,
    UIKitModule,
    RouterModule.forRoot(routes, {}),
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatButtonModule,
    MatSnackBarModule,
    MatToolbarModule,
    CoreModule,
    GalaxyPageModule,
    TranslateModule,
    WspAdminCenterModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    provideProtoTransport(),
    provideErrorTracking(),
    ...GalaxyDefaultProviderOverrides,
    AuthService,
    { provide: OAuthStorage, useFactory: (): OAuthStorage => window.localStorage },
    { provide: 'WebsiteSdkFeatureFlagsService', useClass: FeatureFlagService },
    { provide: FeatureFlagService, useClass: FeatureFlagService },
    SelectedPartnerService,
    AppConfigService,
    WordpressSiteService,
    SnackbarService,
    ApiErrorFactory,
    { provide: OAuth2ServiceConfigToken, useFactory: oauth2ConfigFactory },
    PartnerService,
    UptimeService,
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withInterceptors([cookielessBearerHostInterceptor])),
  ],
})
export class AppModule {}
